import React, { useState, useEffect } from "react";
import "./About.css";
import aboutImage from "../assets/About_us/About_us.png"; 
import founder1 from "../assets/founders/Vikram_Maheshwari.jpg";
import founder2 from "../assets/founders/Vaibhav_Chaudhary.jpg";
import founder3 from "../assets/founders/Sonu_Kabra.jpg";

const About = () => {
  const tabs = ["values", "mission", "vision"];
  const [activeTab, setActiveTab] = useState("values");

  // Auto-Sliding Tabs Every 4 Seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTab((prevTab) => {
        const nextIndex = (tabs.indexOf(prevTab) + 1) % tabs.length;
        return tabs[nextIndex];
      });
    }, 4000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        {/* Title in Center */}
        <h2 className="about-title">Welcome to Lusora</h2>

        {/* Text Left, Image Right */}
        <div className="about-content">
          <div className="about-text">
            <p>
              Welcome to Lusora Food and Beverages that serves pure excellence to its customers. The foundation of our company began when we decided to supply the best packaged drinking water with minerals from untouched springs that promises exceptional taste and quality. At Lusora, we believe in delivering not just water, but a source of life that supports your health and well-being every day.
            </p>
          </div>

          <div className="about-image">
            <img src={aboutImage} alt="About Lusora" />
          </div>
        </div>

        {/* Centered Commitment Section */}
        <div className="about-commitment">
          <h3>Our Commitment to Excellence</h3>
          <div className="about-tabs">
            {tabs.map((tab) => (
              <button 
                key={tab}
                className={activeTab === tab ? "active-tab" : ""} 
                onClick={() => setActiveTab(tab)}>
                {tab === "values" ? "Our Values" : tab === "mission" ? "Our Mission" : "Our Vision"}
              </button>
            ))}
          </div>

          {/* Auto-Sliding Content */}
          <div className="about-info">
            {activeTab === "values" && (
              <div>
                <h3>Our Values</h3>
                <ul>
                  <li><strong>Integrity:</strong> We uphold the highest standards of honesty and transparency in all our operations.</li>
                  <li><strong>Sustainability:</strong>  Dedicated to environmentally responsible practices that preserve natural resources for future generations.</li>
                  <li><strong>Customer Focus:</strong> Prioritizing the satisfaction and well-being of our customers in every decision we make.</li>
                </ul>
              </div>
            )}

            {activeTab === "mission" && (
              <div>
                <h3>Our Mission</h3>
                <ul>
                  <li><strong>Provide Quality Hydration:</strong> Deliver packaged drinking water with minerals that offers essential hydration.</li>
                  <li><strong>Enhance Health:</strong> Promote health and lifestyle improvements through our products.</li>
                  <li><strong>Ensure Sustainability:</strong> Supply pure packaged drinking water with minerals using excellent sustainable practices.</li>
                </ul>
              </div>
            )}

            {activeTab === "vision" && (
              <div>
                <h3>Our Vision</h3>
                <ul>
                  <li><strong>Global Leadership:</strong> Become the leading provider of packaged drinking water with minerals worldwide.</li>
                  <li><strong>Commitment to Excellence:</strong> Be recognized for our dedication to purity, sustainability, and exceptional customer service.</li>
                  <li><strong>Universal Access to Clean Water:</strong> Envision a world where everyone has access to clean, healthy, and refreshing water.</li>
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* Founders Section */}
        <div className="founders-section">
          <h2>Meet Our Team</h2>
          <div className="founders-container">
            <div className="founder-card">
              <img src={founder1} alt="Founder 1" className="founder-img" />
              <h3>Mr. Vikram Maheshwari</h3>
              <h4 className="designations">(Founder)</h4>
              <p>
                "At Lusora, our mission transcends providing just water.
                It's about nurturing health, supporting sustainability, and building lasting
                relationships with our community. We are dedicated to delivering the purest water 
                with the highest quality standards and the label of trust."
              </p>
            </div>
            <div className="founder-card">
              <img src={founder2} alt="Founder 2" className="founder-img" />
              <h3>Mr. Vaibhav Chaudhary</h3>
              <h4 className="designations">(Co-Founder)</h4>
              <p>
                "Our commitment at Lusora goes beyond hydration. We strive to promote sustainability, 
                innovation, and excellence in every drop. Our vision is to provide premium quality 
                packaged drinking water with minerals while maintaining environmental responsibility and consumer trust."               
              </p>
            </div>
            <div className="founder-card">
              <img src={founder3} alt="Founder 3" className="founder-img" />
              <h3>Mrs. Sonu Kabra</h3>
              <h4 className="designations">(Co-Founder)</h4>
              <p>
                "At Lusora, we are dedicated to sourcing the purest water, employing innovative 
                purification methods, and ensuring that every bottle you consume contributes 
                positively to your well-being and our planet. Thank you for choosing Lusora as 
                your trusted source of packaged drinking water."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
